<header id="page-topbar">
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger" id="topnav-hamburger-icon">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
            </div>

            <div class="d-flex align-items-center">
                <div class="dropdown ms-sm-3 header-item topbar-user cis-topbar-user">
                    <button type="button" class="btn cis-user-toggle" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            <span class="cis-user-avatar" aria-hidden="true">
                                <i class="bx bx-user"></i>
                            </span>
                            <span class="cis-user-meta text-start ms-2 d-none d-xl-flex">
                                <span class="cis-user-name">{{ displayName }}</span>
                                <span class="cis-user-details" *ngIf="userRole">
                                    <span class="cis-user-chip cis-user-chip--role">{{ userRole }}</span>
                                </span>
                            </span>
                            <i class="bx bx-chevron-down cis-user-chevron d-none d-xl-inline-block ms-2"></i>
                        </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end cis-user-dropdown">
                        <div class="cis-user-dropdown-header px-3 py-2">
                            <div class="cis-user-name">{{ displayName }}</div>
                            <div class="cis-user-details mt-1" *ngIf="userRole">
                                <span class="cis-user-chip cis-user-chip--role">{{ userRole }}</span>
                            </div>
                        </div>
                        <div class="dropdown-divider my-1"></div>
                        <a class="dropdown-item" href="javascript:void(0);" (click)="logout()">
                            <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle" data-key="t-logout">Logout</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
